import { render, staticRenderFns } from "./FieldsList.vue?vue&type=template&id=5deef385&scoped=true&"
import script from "./FieldsList.vue?vue&type=script&lang=js&"
export * from "./FieldsList.vue?vue&type=script&lang=js&"
import style0 from "./FieldsList.vue?vue&type=style&index=0&id=5deef385&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deef385",
  null
  
)

export default component.exports